import { Store } from "./store";

export const $requirements = () => (store: Store) => store.requirements;